import { Link } from 'react-router-dom'
import './AdminDashboard.css'

export default function AdminDashboard() {
  return (
    <div className="container">
      <h1>Admin Dashboard</h1>
      <p className="text-secondary mb-xl">Manage your campaign content.</p>

      <div className="admin-grid">
        <Link to="/admin/events" className="admin-card">
          <h3>Timeline Events</h3>
          <p>Add, edit, and manage campaign events</p>
        </Link>

        <Link to="/admin/characters" className="admin-card">
          <h3>Characters</h3>
          <p>Manage party member profiles</p>
        </Link>

        <Link to="/admin/albums" className="admin-card">
          <h3>Albums & Songs</h3>
          <p>Upload music and manage albums</p>
        </Link>

        <Link to="/admin/lore" className="admin-card">
          <h3>Lore Articles</h3>
          <p>Write and edit world-building content</p>
        </Link>

        <Link to="/admin/handouts" className="admin-card">
          <h3>Handouts</h3>
          <p>Upload documents and player materials</p>
        </Link>

        <Link to="/admin/ships" className="admin-card">
          <h3>Ships</h3>
          <p>Manage vessels and their crews</p>
        </Link>

        <Link to="/admin/ciphers" className="admin-card">
          <h3>Ciphers</h3>
          <p>Manage secret ciphers and codes</p>
        </Link>

        <Link to="/admin/spells" className="admin-card">
          <h3>Spells</h3>
          <p>Manage custom spells and grant to characters</p>
        </Link>

        <Link to="/admin/spell-schools" className="admin-card">
          <h3>Spell Schools</h3>
          <p>Manage spell schools and their icons</p>
        </Link>

        <Link to="/admin/users" className="admin-card admin-card-users">
          <h3>User Whitelist</h3>
          <p>Manage who can access the site</p>
        </Link>

        <Link to="/admin/login-attempts" className="admin-card admin-card-security">
          <h3>Login Attempts</h3>
          <p>View login history and denied access</p>
        </Link>

        <Link to="/admin/settings" className="admin-card admin-card-settings">
          <h3>Site Settings</h3>
          <p>Customize branding and theme colors</p>
        </Link>
      </div>
    </div>
  )
}
